import styled from '@emotion/styled';
import { ReactNode } from 'react';
import { TypeScribble } from '../../../../@types/generated';
import ScribbleSvgTwo from '../../../assets/svg/scribble-brush-2.svg';
import ScribbleSvgThree from '../../../assets/svg/scribble-brush-long-3.svg';
import ScribbleSvgOne from '../../../assets/svg/scribble-brush.svg';
import ScribbleDoubleStraightSvg from '../../../assets/svg/wordDecorations/brush/brushstroke-double-straight.svg';

const Scribbles = {
  single: ScribbleSvgOne,
  singleLong: ScribbleSvgThree,
  double: ScribbleSvgTwo,
  doubleStraight: ScribbleDoubleStraightSvg,
};

const ScribbleWrapper = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: -1;
`;

type Props = {
  children?: ReactNode;
  className?: string;
  variant?: 'single' | 'singleLong' | 'double' | 'doubleStraight';
  scribble?: TypeScribble | keyof typeof Scribbles;
};

const Brush = ({ children, variant = 'single', className, scribble }: Props) => {
  const Scribble = styled(scribble || Scribbles[variant])`
    width: 100%;
    height: 100%;
  `;

  return (
    <span style={{ position: 'relative', display: 'inline-block' }}>
      <ScribbleWrapper aria-hidden className={className}>
        <Scribble />
      </ScribbleWrapper>
      {children}
    </span>
  );
};

export default Brush;
